import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaHome, FaStar } from "react-icons/fa";
import { getBIParams, getDimTableByTableName, getReprocessRollupCount } from "../services/dimension-service";
import { useEffect, useMemo, useState } from "react";
import { LoadingTable } from "../shared/LoadingTable";
import { useGetToken } from "../hooks/custom-hooks";
import "../styles/DimTables.css";
import "../styles/Modules.css";
import "../styles/loading-states.css";
import { EditDimensionModal } from "../pop-ups/edit-dimension-popup";
import { CommerceDimensionTable } from "../shared/CommerceDimensionTable";
import { ReprocessPopup } from "../pop-ups/reprocess-popup";
import { ReprocessRollUp } from "../partials/ReprocessRollUp";
import { useCommerceDimensionTable } from "../hooks/useCommerceDimTable";
import { useDimensionModal } from "../hooks/useCommerceDimModal";
import { CommerceMainDimTable } from "../partials/CommerceMainDimTable";
import { DimRelationshipSidebar } from "../partials/DimRelationshipSidebar";

export const CommerceDimTableLanding = () => {
  const navigate = useNavigate();
  const { dimTable } = useParams();

  const {
    config,
    rows,
    columns,
    relationships,
    visibleColumns,
    lookupMaps,
    filteredRows,
    statuses,
    saleSources,
    hasRelationships,
    isLoading,
    error,
    refresh,
    filter,
    setFilter,
    selectedStatus,
    setSelectedStatus,
    selectedSaleSource,
    setSelectedSaleSource,
    lookupFilters,
    updateLookupFilter,
    columnFilters,
    handleColumnFilterChange,
  } = useCommerceDimensionTable(dimTable);

  const {
    isOpen,
    selectedDimension,
    modalConfig,
    openMainDimension,
    openLookupDimension,
    close,
  } = useDimensionModal({
    config,
    columns,
    relationships,
    rows,
    onRefresh: refresh,
  });

  const handleBack = () => {
    navigate("/CommerceManagement");
  };

  const token = useGetToken();
  const [reprocessCount, setReprocessCount] = useState(0);

  useEffect(() => {
    const fetchReprocessCount = async () => {
      const result = await getReprocessRollupCount("commerce", token);
      setReprocessCount(result?.data?.count ?? 0);
    };
    if (token !== null) {
      fetchReprocessCount();
    }
  }, [token]);


  if (isLoading) {
    return (
      <div className="App Full-Page">
        <div className="header-content">
          <div className="landing-page-actions">
            <div
              type="button"
              className="App-text back-btn"
              onClick={handleBack}
            >
              <FaHome /> Home
            </div>

            <div
              className="action-btn-row"
              style={{ gap: "20px" }}
            />
          </div>

          <div
            className="title-search-container"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="loading-dimTable-title" />
          </div>
        </div>

        <div className="dim-content-container">
          <LoadingTable />
        </div>
      </div>
    );
  }

  return (
    <div className="App Full-Page">
      <div className="header-content">
        <div className="landing-page-actions">
          <div
            type="button"
            className="App-text back-btn"
            onClick={handleBack}
          >
            <FaHome /> Home
          </div>

          <div
            className="action-btn-row"
            style={{ gap: "20px" }}
          >
            <ReprocessRollUp 
              rollupType={"concessionsRollup"}
              reprocessCount={reprocessCount}
            />
          </div>
        </div>
      </div>

      <div
        className={`com-dim-container ${
          hasRelationships
            ? "has-sidebar"
            : "full-width"
        }`}
      >
        <main className="dim-content-container">
          <CommerceMainDimTable
            config={config}
            visibleColumns={visibleColumns}
            filteredRows={filteredRows}
            lookupMaps={lookupMaps}
            statuses={statuses}
            selectedStatus={selectedStatus}
            onStatusChange={
              setSelectedStatus
            }
            saleSources={saleSources}
            selectedSaleSource={
              selectedSaleSource
            }
            onSaleSourceChange={
              setSelectedSaleSource
            }
            searchValue={filter}
            onSearchChange={setFilter}
            onRowClick={openMainDimension}
            columnFilters={columnFilters}
            onColumnFilterChange={handleColumnFilterChange}
          />
        </main>

        <DimRelationshipSidebar
          relationships={relationships}
          config={config}
          rows={rows}
          lookupFilters={lookupFilters}
          onLookupFilterChange={
            updateLookupFilter
          }
          onRowClick={openLookupDimension}
          close={close}
        />
      </div>

      {isOpen &&
        selectedDimension &&
        modalConfig && (
          <EditDimensionModal
            isOpen={isOpen}
            dimension={selectedDimension}
            config={modalConfig}
            onClose={close}
          />
        )}
    </div>
  );
};
